import React, { PureComponent } from 'react';
import compact from 'lodash/compact';

import classes from './controls.module.scss';

interface Props {
  className?: string;
  disabled?: boolean;
  input: any; // input (compatible with redux-form: { name, value, checked, ...[onEvents] })
  label?: string;
  labelLeft?: boolean;
  meta?: any; // meta (for compatibility with redux-form: { active, dirty, ... })
  type?: string;// type (even though it is hard-coded here, it is necessary for compatibility with redux-form)
}

class Radio extends PureComponent<Props> {
  render() {
    const { className, disabled, input, label, labelLeft, ...otherProps } = this.props; // disabled can be a prop on the main Field element or inside its props prop
    const containerClasses = compact([
      classes.container,
      classes.radiobutton,
      label && (labelLeft ? classes.labelLeft : classes.labelRight),
      disabled && classes.disabled,
      className
    ]).join(' ');
    
    return (
      <label className={containerClasses} {...otherProps}>
        <div className={classes.ctrlPad}>
          <div className={classes.ctrlFrame}>
            <input disabled={disabled} type="radio" {...input} />
            <span className={classes.ctrl}></span>
          </div>
        </div>
        {label && (
          <div className={classes.label}>{label}</div>
        )}
      </label>
    );
  }
}

export default Radio;
